<!-- <p>incident-security-callback works!</p> -->
<mat-card
  [ngClass]="{
    'incident-table-card':
      screenSize == ScreenType.Desktop || screenSize == ScreenType.Tablet,
    'incident-table-card-mobile': screenSize == ScreenType.Mobile
  }"
>
  <mat-card-content
    [ngClass]="{
      'incident-table-card-content': showHeader,
      'incident-table-card-content-custom': !showHeader
    }"
  >
    <div *ngIf="false" class="incident-table-description">
      <h4>Urgent action/calls</h4>
      <div></div>
    </div>
    <div
      *ngIf="filteredDataSource.data.length == 0 && false"
      class="preview-content-empty"
    >
      No Data Available <mat-divider></mat-divider>
    </div>
    <div
      class="search-box-container"
      *ngIf="filteredDataSource.data.length != 0"
    >
      <mat-form-field appearance="outline" [subscriptSizing]="'dynamic'">
        <mat-label>Search</mat-label>
        <input matInput (keyup)="applyFilterCustom($event)" #input />
      </mat-form-field>
    </div>
    <div
      class="visitors-table"
      *ngIf="screenSize != ScreenType.Mobile && showHeader"
    >
      <!-- <mat-paginator
        [pageSizeOptions]="[10, 25, 100]"
        [pageSize]="10"
        aria-label="Select page of users"
      ></mat-paginator> -->
      <table
        mat-table
        [dataSource]="filteredDataSource"
        matSort
        multiTemplateDataRows
        cdkDropList
        cdkDropListOrientation="horizontal"
        (cdkDropListDropped)="drop($event)"
      >
        <ng-container matColumnDef="no">
          <th mat-header-cell *matHeaderCellDef cdkDrag>No.</th>
          <td mat-cell *matCellDef="let element; let i = index">
            {{ i + 1 }}
          </td>
        </ng-container>
        <ng-container matColumnDef="name">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Incident Name
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.incidentName }}
          </td>
        </ng-container>
        <ng-container matColumnDef="date">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Date
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.eventCreateDate | date : "E, MMMM d, y" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="Details">
          <th
            style="text-align: center"
            mat-header-cell
            *matHeaderCellDef
            aria-label="row actions"
          >
            Details
          </th>
          <td style="text-align: center" mat-cell *matCellDef="let element">
            <button
              [disabled]="isShowDetails && expandedDetail == element.incidentId"
              (click)="onShowDetails(element)"
              mat-raised-button
            >
              <mat-icon *ngIf="expandedDetail != element.incidentId"
                >add</mat-icon
              >
              <mat-icon
                *ngIf="isShowDetails && expandedDetail == element.incidentId"
                >remove</mat-icon
              >
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="time">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Time
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.eventCreateDate | date : "hh:mm a" }}
          </td>
        </ng-container>
        <ng-container matColumnDef="asset">
          <th
            style="border-right: 1px solid"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Assigned
          </th>
          <td style="border-right: 1px solid" mat-cell *matCellDef="let row">
            {{ row.assignedTo }}
          </td>
        </ng-container>
        <ng-container matColumnDef="evidence">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
            mat-sort-header
            cdkDrag
          >
            Evidence
          </th>
          <td
            style="border-right: 1px solid; text-align: center"
            mat-cell
            *matCellDef="let row"
          >
            <img [src]="row.eventEvidence" />
          </td>
        </ng-container>
        <ng-container matColumnDef="action">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
            cdkDrag
          >
            Status
          </th>
          <td
            style="border-right: 1px solid; text-align: center"
            mat-cell
            *matCellDef="let row"
          >
            <button
              [ngStyle]="
                row.incidentStatus == 3
                  ? { 'background-color': '#ffbf00' }
                  : row.incidentStatus == 0
                  ? { 'background-color': 'green' }
                  : row.incidentStatus == 1
                  ? { 'background-color': 'red' }
                  : { 'background-color': 'gray' }
              "
              (click)="onClickStatus(row)"
              mat-raised-button
            >
              {{
                row.incidentStatus == 1
                  ? "Closed"
                  : row.incidentStatus == 0
                  ? "Open"
                  : row.incidentStatus == 2
                  ? "Verified"
                  : row.incidentStatus == 3
                  ? "Snoozed"
                  : row.incidentStatus == 4
                  ? "In-Progress"
                  : row.incidentStatus == 5
                  ? "On-Hold"
                  : row.incidentStatus == 6
                  ? "Approved"
                  : row.incidentStatus == 7
                  ? "Rejected"
                  : row.incidentStatus == 8
                  ? "Completed"
                  : ("Not Specified" | titlecase)
              }}
            </button>
          </td>
        </ng-container>
        <ng-container matColumnDef="details">
          <th
            style="border-right: 1px solid; text-align: center"
            mat-header-cell
            *matHeaderCellDef
            aria-label="row actions"
          ></th>
          <td
            style="border-right: 1px solid; text-align: center"
            mat-cell
            *matCellDef="let element"
          >
            <!-- <button (click)="onShowDetails(element)" mat-raised-button>
              <mat-icon>add</mat-icon>
            </button> -->
            <!-- <button
              [disabled]="element.incidentStatus == '3'"
              (click)="onSnoozeIncident(element)"
              mat-raised-button
            >
              {{ element.incidentStatus == "3" ? "Snoozed" : "Snooze" }}
            </button> -->
          </td>
        </ng-container>
        <tr
          class="table-header"
          mat-header-row
          *matHeaderRowDef="displayedColumns; sticky: true"
        ></tr>
        <tr mat-row *matRowDef="let row; columns: displayedColumns"></tr>
        <div class="not-matched" *ngIf="!!filteredDataSource && !!temp.length">
          <tr class="mat-row" *matNoDataRow></tr>
        </div>
      </table>
      <div class="data-not-found" *ngIf="!temp.length">
        {{ "No Incident Data available" | uppercase }}
      </div>
    </div>
    <div
      class="mobile-table-card"
      [ngStyle]="showHeader ? { 'margin-top': '0px' } : {}"
      *ngIf="screenSize === ScreenType.Mobile || !showHeader"
    >
      <app-mobile-table-card
        [incidentTableData]="filtered"
        [tableType]="'incidentSecurity'"
        (showDetails)="onShowDetails($event)"
        (snoozeIncident)="onClickStatus($event)"
      ></app-mobile-table-card>
    </div>
  </mat-card-content>
</mat-card>
